<div class="data-section-settings space-y-4">
  <!-- Datos (Campos) para esta sección -->
  <div class="space-y-2 mt-4" *ngIf="dataRequest.length">
    <span class="text-xs font-medium">Datos a Solicitar</span>
    <div *ngFor="let field of dataRequest"
          class="w-full mt-2 border-1 border-gray-200 p-2 rounded-md">
      <div class="flex flex-row justify-between items-start">
        <div class="flex flex-col">
          <p class="text-lg font-semibold">{{ field.fieldName }}</p>
          <p class="text-xs text-gray-600">{{ field.fieldType }}</p>
        </div>
        <!-- Acciones del campo de datos (botones) -->
        <div class="space-y-2">
          <div class="flex gap-2 flex-wrap">
            <button pButton type="button" label="Requerido"
                    (click)="setDataRequestStatus(field.fieldId, 'required')"
                    [class.p-button-primary]="dataRequestStatus[field.fieldId] === 'required'"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
            <button pButton type="button" label="Opcional"
                    (click)="setDataRequestStatus(field.fieldId, 'optional')"
                    [class.p-button-primary]="dataRequestStatus[field.fieldId] === 'optional'"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
            <button pButton type="button" label="No usar"
                    (click)="setDataRequestStatus(field.fieldId, 'not_used')"
                    [class.p-button-primary]="dataRequestStatus[field.fieldId] === 'not_used' || !dataRequestStatus[field.fieldId]"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Documentos para esta sección -->
  <div class="space-y-2 mt-4" *ngIf="documentRequest.length">
    <span class="text-xs font-medium">Documentos</span>
    <div *ngFor="let doc of documentRequest"
          class="w-full mt-2 border-1 border-gray-200 p-2 rounded-md">
      <div class="flex flex-row justify-between items-start">
        <div class="flex flex-col">
          <p class="text-lg font-semibold">{{ doc.docName }}</p>
          <p class="text-xs text-gray-600">{{ doc.docDescription }}</p>
        </div>
        <!-- Acciones del documento (botones) -->
        <div class="space-y-2">
          <div class="flex gap-2 flex-wrap">
            <button pButton type="button" label="Requerido"
                    (click)="setDocumentStatus(doc.requestedDocId, 'required')"
                    [class.p-button-primary]="documentStatus[doc.requestedDocId] === 'required'"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
            <button pButton type="button" label="Opcional"
                    (click)="setDocumentStatus(doc.requestedDocId, 'optional')"
                    [class.p-button-primary]="documentStatus[doc.requestedDocId] === 'optional'"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
            <button pButton type="button" label="No usar"
                    (click)="setDocumentStatus(doc.requestedDocId, 'not_used')"
                    [class.p-button-primary]="documentStatus[doc.requestedDocId] === 'not_used' || !documentStatus[doc.requestedDocId]"
                    class="bg-white hover:bg-naranja text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
